import Vue from 'vue';
import VueSocketio from 'vue-socket.io-extended';
import io from 'socket.io-client';
import { v1 as uuidv1 } from 'uuid';
import Util from '@/util';

const socketio = io(process.env.VUE_APP_API_URL, {
  transports: ['websocket'],
  autoConnect: false,
  reconnection: true,
});

// hack to restart socket connection
const reconnectSocket = function() {
  console.log('Retry websocket connection');

  socketio.io.opts.query = {
    token: localStorage.jwtToken,
    'device-id': localStorage.deviceId,
  };

  socketio.close();
  socketio.open();
};

export const initializeSocketModule = (store) => {
  Vue.use(VueSocketio, socketio, { store });
};

const state = {
  connected: false,
};

const getters = {
  connected: state => state.connected,
};

const mutations = {
  SOCKET_CONNECT: (state) => {
    console.log('Socket: connected');
    state.connected = true;
  },
  SOCKET_ERROR: (state) => {
    console.log('Socket: not connected');
    state.connected = false;
  },
  SOCKET_DISCONNECT: (state) => {
    console.log('Socket: disconnected');
    state.connected = false;
  },
  SOCKET_CONNECT_ERROR: (state) => {
    console.log('Socket: connect error');
    state.connected = false;
  },
  SOCKET_RECONNECT: () => {
    console.log('Socket: reconnecting');
  },
  CLOSE_SOCKET: (state) => {
    state.connected = false;
  },
};

const actions = {
  socket_chatmsg: ({rootGetters, commit, dispatch}, message) => {
    let msg = message;
    if (typeof msg === 'string') {
      msg = JSON.parse(msg);
    }
    const chat = msg.chatId && rootGetters.chatById(msg.chatId);

    if (msg.deviceId === localStorage.deviceId) {
      return;
    }
    if (msg.type === 'chatmsg') {
      msg.type = 'text';
    }

    if (['chatCreated', 'chatUpdated'].includes(msg.type)) {
      commit('UPDATE_CHAT', msg.chat);
    } else if (msg.type === 'chatUnauthorized') {
      commit('REMOVE_CHAT', msg.chatId);
    } else if (['assign', 'unassign', 'end', 'text', 'image', 'videostart', 'videoend'].includes(msg.type)) {
      commit('ADD_CHAT_MESSAGE', msg);

      if(chat && msg.userId !== rootGetters.profile.userId) {
        commit('INCREASE_CHAT_UNSEEN_MESSAGES', {
          chatId: chat.chatId,
          unseenMessages: 1,
        });
      }
    } else if (msg.type === 'clientConnect') {
      commit('WEBSOCKET_ADD_CLIENT', msg.parameters.profileIds);
      commit('SET_LOGGED_IN_USERS', msg.parameters.profileIds);
    } else if (msg.type === 'clientDisconnect') {
      if(msg.message === rootGetters.profile.userId) {
        dispatch('connectSocket');
      } else {
        commit('WEBSOCKET_REMOVE_CLIENT', msg.message);
        commit('REMOVE_LOGGED_IN_USER', msg.message);
      }
    } else {
      console.error(`Unprocessed message type: ${msg.type}`);
    }

    if (msg.type === 'text') {
      if (chat && chat.status === rootGetters.profile.userId) {
        const options = {
          body: 'Asiakas on lähettänyt sinulle viestin LemmikkiHelppiin.',
          icon: '/notification/Notification_icon1x.png',
        };
        Util.sendNotification(options, 'Uusi viesti');
      }
    } else if (msg.type === 'image') {
      if (chat && chat.status === rootGetters.profile.userId) {
        const options = {
          body: 'Asiakas on lähettänyt sinulle kuvan LemmikkiHelppiin.',
          icon: '/notification/Notification_icon1x.png',
        };
        Util.sendNotification(options,'Uusi viesti');
      }
    } else if (msg.type === 'chatCreated') {
      if (!chat) {
        const options = {
          body: 'LemmikkiHelppiin on auennut uusi keskustelu.',
          icon: '/notification/Notification_icon1x.png',
        };
        Util.sendNotification(options, 'Uusi keskustelu jonossa');
      }
    }
  },
  sendMessage ({ commit }, {chatId, content}) {
    const message = content.trim();
    const chatmsg = {
      message,
      messageId: uuidv1(),
      type: 'text',
      chatId,
      deviceId: localStorage.deviceId,
    };
    socketio.emit('chatmsg', chatmsg, (savedMessage) => {
      // successful
      commit('ADD_CHAT_MESSAGE', savedMessage);
    });
  },
  connectSocket() {
    reconnectSocket();
  },
  closeSocket({commit}) {
    socketio.close();
    commit('CLOSE_SOCKET');
  }
};

export default {
  state,
  getters,
  actions,
  mutations,
};
